// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.push-notification-container {
    width: 1100px;
    padding: 16px;
    background: #FFFFFF;
    border-radius: 12px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 16px;
    margin-left: 266px; /* Adjusted for Sidebar width */
}

.push-notification-container h2 {
    font-size: 24px;
    color: #333333;
}

/* Input and Submit Button Styles */
.input-field, .textarea-field, .input-file {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 16px;
    resize: none;
    outline: none;
}

.textarea-field {
    min-height: 100px;
}

/* Primary Submit Button */
.submit-btn {
    padding: 12px;
    width: 150px;
    border-radius: 8px;
    border: none;
    background-color: #FF0000;
    color: white;
    font-size: 16px;
    cursor: pointer;
    align-self: flex-start;
    transition: background-color 0.3s ease;
}

.submit-btn:hover {
    background-color: #d40000;
}

/* Status Text */
.status-text {
    color: #333;
    font-size: 14px;
    margin-top: 8px;
}

/* Notification History Section */
.notification-history {
    margin-top: 30px;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 12px;
}

.notification-history h3 {
    font-size: 20px;
    color: #333;
    margin-bottom: 10px;
}

.history-item {
    padding: 16px;
    margin-bottom: 12px;
    background: #FFF;
    border: 1px solid #DFE7EF;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    font-size: 14px;
}

.history-item strong {
    color: #4B5563;
}

.history-item + .history-item {
    margin-top: 10px;
}

/* History Toggle Button */
.history-btn {
    padding: 10px 16px;
    border: none;
    background-color: #2196F3;
    color: white;
    font-size: 14px;
    font-weight: bold;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.history-btn:hover {
    background-color: #1e88e5;
}

/* File Input Button */
.input-file {
    cursor: pointer;
    color: #333;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 12px;
}

.input-file::file-selector-button {
    padding: 8px 12px;
    margin-right: 8px;
    border: none;
    border-radius: 6px;
    background-color: #FF9800;
    color: white;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.input-file::file-selector-button:hover {
    background-color: #f57c00;
}
`, "",{"version":3,"sources":["webpack://./src/style/PushNotification.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB,EAAE,+BAA+B;AACvD;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".push-notification-container {\n    width: 1100px;\n    padding: 16px;\n    background: #FFFFFF;\n    border-radius: 12px;\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-top: 16px;\n    margin-left: 266px; /* Adjusted for Sidebar width */\n}\n\n.push-notification-container h2 {\n    font-size: 24px;\n    color: #333333;\n}\n\n/* Input and Submit Button Styles */\n.input-field, .textarea-field, .input-file {\n    width: 100%;\n    padding: 12px;\n    border-radius: 8px;\n    border: 1px solid #ccc;\n    font-size: 16px;\n    resize: none;\n    outline: none;\n}\n\n.textarea-field {\n    min-height: 100px;\n}\n\n/* Primary Submit Button */\n.submit-btn {\n    padding: 12px;\n    width: 150px;\n    border-radius: 8px;\n    border: none;\n    background-color: #FF0000;\n    color: white;\n    font-size: 16px;\n    cursor: pointer;\n    align-self: flex-start;\n    transition: background-color 0.3s ease;\n}\n\n.submit-btn:hover {\n    background-color: #d40000;\n}\n\n/* Status Text */\n.status-text {\n    color: #333;\n    font-size: 14px;\n    margin-top: 8px;\n}\n\n/* Notification History Section */\n.notification-history {\n    margin-top: 30px;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n}\n\n.notification-history h3 {\n    font-size: 20px;\n    color: #333;\n    margin-bottom: 10px;\n}\n\n.history-item {\n    padding: 16px;\n    margin-bottom: 12px;\n    background: #FFF;\n    border: 1px solid #DFE7EF;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    font-size: 14px;\n}\n\n.history-item strong {\n    color: #4B5563;\n}\n\n.history-item + .history-item {\n    margin-top: 10px;\n}\n\n/* History Toggle Button */\n.history-btn {\n    padding: 10px 16px;\n    border: none;\n    background-color: #2196F3;\n    color: white;\n    font-size: 14px;\n    font-weight: bold;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.history-btn:hover {\n    background-color: #1e88e5;\n}\n\n/* File Input Button */\n.input-file {\n    cursor: pointer;\n    color: #333;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.input-file::file-selector-button {\n    padding: 8px 12px;\n    margin-right: 8px;\n    border: none;\n    border-radius: 6px;\n    background-color: #FF9800;\n    color: white;\n    font-weight: bold;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.input-file::file-selector-button:hover {\n    background-color: #f57c00;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
